import LanguagesSection from './languagesSection'

import Modal from 'common/components/modal'
import useLayout from 'common/hooks/useLayout'
import Icon from 'common/components/icons'
import { useTransmissionContext } from 'modules/transmission/context'

import './configMenuMobile.scss'

const ConfigMenuMobile = () => {
  const { isDesktop } = useLayout()
  const { languageModalRef } = useTransmissionContext()

  if (isDesktop) {
    return null
  }

  const handleCloseModal = () => {
    languageModalRef?.current?.closeModal()
  }

  return (
    <div data-test="config-menu-mobile" className="config-menu-mobile">
      <Modal ref={languageModalRef}>
        <div className="content">
          <button onClick={handleCloseModal} className="icon-container">
            <Icon className="icon" prefix="far" iconName="angle-down" />
          </button>
          <LanguagesSection />
        </div>
      </Modal>
    </div>
  )
}

export default ConfigMenuMobile
